import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import {
  HashRouter,
  Route,
  Switch,
  Redirect,
  useHistory,
} from "react-router-dom";

import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";

import AuthLayout from "layouts/Auth.js";
import AdminLayout from "layouts/Admin.js";
import MerchantLayout from "layouts/Merchant";

import "./i18n";
import store from "./state/store";
import PrivateRoute from "routes/PrivateRoute";

import SessionExpiredModal from "components/Modals/SessionExpiredModal";
import { setSessionExpiredHandler } from "utils/sessionExpired";

const AppContent = () => {
  const history = useHistory();

  const [
    sessionExpiredVisible,
    setSessionExpiredVisible,
  ] = useState(false);

  useEffect(() => {
    setSessionExpiredHandler(() => {
      setSessionExpiredVisible(true);
    });
  }, []);

  const handleLogin = () => {
    setSessionExpiredVisible(false);
    history.push("/auth/signin");
  };

  return (
    <>
      <Switch>
        <Route
          path="/auth"
          component={AuthLayout}
        />

        <PrivateRoute
          path="/admin"
          component={AdminLayout}
        />

        <PrivateRoute
          path="/merchant"
          component={MerchantLayout}
        />

        <Redirect
          from="/"
          to="/auth/signin"
        />
      </Switch>

      <SessionExpiredModal
        open={sessionExpiredVisible}
        onLogin={handleLogin}
      />
    </>
  );
};

function App() {
  return (
    <Provider store={store}>
      <HashRouter>
        <AppContent />
      </HashRouter>
    </Provider>
  );
}

ReactDOM.render(
  <App />,
  document.getElementById("root")
);

// Uncomment this line if the service worker is causing issues
// serviceWorkerRegistration.unregister();
serviceWorkerRegistration.register();

reportWebVitals();
